import { gql, type TypedDocumentNode } from "@apollo/client";

export enum JobApplicantCountEstimateMatchTier {
  EXACT = "EXACT",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  GLOBAL = "GLOBAL"
}

export type JobApplicantCountEstimate = {
  low: number;
  high: number;
  median: number;
  sampleSize: number;
  matchTier: JobApplicantCountEstimateMatchTier;
  estimatorVersion: string;
  disclaimer: string;
  criteriaComplete: boolean;
  missingCriteria: string[];
};

export const JOB_APPLICANT_COUNT_ESTIMATE_FRAGMENT: TypedDocumentNode<
  JobApplicantCountEstimate,
  Record<string, never>
> = gql`
  fragment JobApplicantCountEstimateFields on JobApplicantCountEstimate {
    low
    high
    median
    sampleSize
    matchTier
    estimatorVersion
    disclaimer
    criteriaComplete
    missingCriteria
  }
`;

export type FacilityEstimateGeographyQueryResponse = {
  facility: {
    id: string;
    mainAddress: { state: string | null } | null;
    mailingAddress: { state: string | null } | null;
    section: { name: string | null } | null;
  } | null;
};

export type FacilityEstimateGeographyQueryVariables = {
  facilityId: string;
};

export const FACILITY_ESTIMATE_GEOGRAPHY_QUERY: TypedDocumentNode<
  FacilityEstimateGeographyQueryResponse,
  FacilityEstimateGeographyQueryVariables
> = gql`
  query FacilityEstimateGeography($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      mainAddress {
        state
      }
      mailingAddress {
        state
      }
      section {
        name
      }
    }
  }
`;
